const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autocomplete="off"
							value=""
						/>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field has-addons has-addons-right mb-0">
							<p class="control control-status is-expanded">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autocomplete="off"
									value=""
								/>
							</p>
							{~UnitsAddon:Record~}
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input',
			DefaultInputExtensions: [ 'InputValidation' ],
			Template: /*HTML-Partial*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field has-addons has-addons-right mb-0">
				<p class="control control-status">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="text"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Mid-Input',
			Template: /*HTML-Partial*/` `,
		},
		{
			HashPostfix: '-TabularTemplate-InformaryAddress-Input',
			Template: /*HTML-Partial*/`
					data-i-index="{~D:Context[2].Key~}"
					onchange="_Pict.views['{~D:Context[0].Hash~}'].dataChangedTabular('{~D:Context[2].Group~}', '{~D:Record.PictForm.InputIndex~}', '{~D:Context[2].Key~}')" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input',
			Template: /*HTML-Partial*/`
						value=""
					/>
				</p>
				{~UnitsAddon:Record~}
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="text"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="text"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									readonly aria-readonly="true"
									value=""
								/>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input',
			Template: /*HTML-Partial*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<input
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				type="text"
				class="input"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}
				readonly aria-readonly="true"`,
		},
		{
			HashPostfix: '-TabularTemplate-Mid-Input',
			Template: /*HTML-Partial*/` `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input',
			Template: /*HTML-Partial*/`
				value=""
			/>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input',
			Template: /*HTML*/`
			<!-- DEFAULT Input {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~} {~LabelAlignment:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<div class="control">
								<div
									id="{~D:Record.Macro.RawHTMLID~}"
									class="input is-static"
									{~D:Record.Macro.InputFullProperties~}
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input',
			Template: /*HTML-Partial*/`
			<!-- DEFAULT Input {~"D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-Mid-Input',
			Template: /*HTML-Partial*/` `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
